import React from "react";
import { useNavigate } from 'react-router-dom';

const HireSection = ({ imageSrc, title, description, buttonText,className }) => {
  const navigate = useNavigate();
  return (
    <section className={`hire-section-unique ${className}`}>
      <div className="hire-image-unique">
        <img src={imageSrc} alt="Hire Section" />
      </div>
      <div className={`hire-content-unique `}>
        <h1 className="hire-title-unique">{title}</h1>
        <p className="hire-description-unique">{description}</p>
        {buttonText.map((button, index) => (
      <button key={index}  onClick={() => navigate('/meet-the-experts')} className={`hire-button-unique ${button.buttonClass}`}> 
        {button.text}  {/* Access button.text here */}
      </button>
  ))}
      </div>
    </section>
  );
};

export default HireSection;
  